var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueGooLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ldio-6rvhs4bg9nf-filter",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 2.4000000000000004
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    result: "cutoff"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "0 0 0 0 0 0 1 1 1 1 1"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ldio-6rvhs4bg9nf-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#309bde"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "-0.25s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "4s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#1b75be"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.2s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "-0.05s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#408ee0"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "1.3333333333333333s",
    repeatCount: "indefinite",
    begin: "-0.15s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "1.3333333333333333s",
    repeatCount: "indefinite",
    begin: "-0.1s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#89bff8"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.1s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.15s"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 0,
    r: 5,
    fill: "#0072ff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "3.5999999999999996;8.399999999999999;3.5999999999999996",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: "-0.05s"
  })), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "0.8s",
    repeatCount: "indefinite",
    begin: "-0.2s"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueGooLoading);
export default __webpack_public_path__ + "static/media/blue-goo-loading.4576a81715dd41538637268e8b5ca911.svg";
export { ForwardRef as ReactComponent };